// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Semigroupoid from "../Control.Semigroupoid/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Monoid_Extra from "../Data.Monoid.Extra/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_CodePoints from "../Data.String.CodePoints/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Data_Vault from "../Data.Vault/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record_Builder from "../Record.Builder/index.js";
import * as Restaumatic_Common_Translations_Keys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Value from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_ChoiceRef from "../Specular.ChoiceRef/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FRP_Replaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_MultiChoiceRef from "../Specular.MultiChoiceRef/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Equality from "../Type.Equality/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe_Coerce from "../Unsafe.Coerce/index.js";
var write1 = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var identity = /* #__PURE__ */ Control_Category.identity(Record_Builder.categoryBuilder);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var identity1 = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var wrap = /* #__PURE__ */ Data_Newtype.wrap();
var fromFoldable = /* #__PURE__ */ Data_Set.fromFoldable(Data_Foldable.foldableArray);
var toUnfoldable = /* #__PURE__ */ Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray);
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var triggerCallback = /* #__PURE__ */ Specular_Callback.triggerCallback();
var bindFinal = /* #__PURE__ */ Restaumatic_Form_Final.bindFinal();
var pure3 = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var map1 = /* #__PURE__ */ Data_Functor.map(Restaumatic_Form_DynamicResult.functorDynamicResult);
var mwhen = /* #__PURE__ */ Data_Monoid_Extra.mwhen(Data_Monoid.monoidArray);
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Base.bindDynamic);
var ordMaybe = /* #__PURE__ */ Data_Maybe.ordMaybe(/* #__PURE__ */ Data_Ord.ordArray(Data_Ord.ordString));
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(ordMaybe);
var insertWith = /* #__PURE__ */ Data_Map_Internal.insertWith(ordMaybe);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var $$delete = /* #__PURE__ */ Data_Map_Internal["delete"](ordMaybe);
var map2 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var map3 = /* #__PURE__ */ Data_Functor.map(Specular_Select.functorOption);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Restaumatic_Form_DynamicResult.applyDynamicResult);
var munless = /* #__PURE__ */ Data_Monoid_Extra.munless(Data_Monoid.monoidArray);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var measure = /* #__PURE__ */ Specular_Profiling.measure(Effect_Class.monadEffectEffect);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var pure4 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Errors.semigroupFormErrors));
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Validation_Semigroup.traversableV)(Specular_FRP_Base.applicativeDynamic);
var map4 = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Host.functorHost);
var bind2 = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var apply1 = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Host.applyHost);
var composeFlipped = /* #__PURE__ */ Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder);
var insert = /* #__PURE__ */ Record_Builder.insert()();
var fixDelayed = /* #__PURE__ */ Restaumatic_Form_Delayed.fixDelayed(Specular_FRP_Host.monadEffectHost);
var updateRef = /* #__PURE__ */ Specular_Ref.updateRef(Effect_Class.monadEffectEffect);
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var lastValidIsSymbol = {
    reflectSymbol: function () {
        return "lastValid";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(lastValidIsSymbol);
var UndefinedIsSymbol = {
    reflectSymbol: function () {
        return "Undefined";
    }
};
var editValueIsSymbol = {
    reflectSymbol: function () {
        return "editValue";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(editValueIsSymbol);
var errorIsSymbol = {
    reflectSymbol: function () {
        return "error";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(errorIsSymbol);
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var InvalidIsSymbol = {
    reflectSymbol: function () {
        return "Invalid";
    }
};
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var showRecordFieldsConsNil1 = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(valueIsSymbol);
var ValidIsSymbol = {
    reflectSymbol: function () {
        return "Valid";
    }
};
var mapFlipped1 = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableArray)(Specular_FRP_Base.applicativeDynamic);
var find = /* #__PURE__ */ Data_Foldable.find(Data_Foldable.foldableArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Foldable.foldableArray)(Data_Semiring.semiringInt);
var genericEncodeConstructor = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(UndefinedIsSymbol);
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons1(lastValidIsSymbol);
var genericEncodeConstructor1 = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(InvalidIsSymbol);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Form_Errors.encodeFormErrors);
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var genericEncodeConstructor2 = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ValidIsSymbol);
var encodeRecordCons3 = /* #__PURE__ */ encodeRecordCons1(valueIsSymbol);
var sequence1 = /* #__PURE__ */ Data_Traversable.sequence(Data_Traversable.traversableMaybe)(Specular_FRP_Base.applicativeDynamic);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode));
var fromFoldable1 = /* #__PURE__ */ Foreign_Object.fromFoldable(Data_Foldable.foldableArray);
var toUnfoldable1 = /* #__PURE__ */ Foreign_Object.toUnfoldable(Data_Unfoldable.unfoldableArray);
var discard2 = /* #__PURE__ */ discard(Specular_FRP_Host.bindHost);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var WithOptions = function (x) {
    return x;
};
var WithId = /* #__PURE__ */ (function () {
    function WithId(value0) {
        this.value0 = value0;
    };
    WithId.create = function (value0) {
        return new WithId(value0);
    };
    return WithId;
})();
var Undefined = /* #__PURE__ */ (function () {
    function Undefined(value0) {
        this.value0 = value0;
    };
    Undefined.create = function (value0) {
        return new Undefined(value0);
    };
    return Undefined;
})();
var Invalid = /* #__PURE__ */ (function () {
    function Invalid(value0) {
        this.value0 = value0;
    };
    Invalid.create = function (value0) {
        return new Invalid(value0);
    };
    return Invalid;
})();
var Valid = /* #__PURE__ */ (function () {
    function Valid(value0) {
        this.value0 = value0;
    };
    Valid.create = function (value0) {
        return new Valid(value0);
    };
    return Valid;
})();
var SomeMetadata = /* #__PURE__ */ (function () {
    function SomeMetadata(value0) {
        this.value0 = value0;
    };
    SomeMetadata.create = function (value0) {
        return new SomeMetadata(value0);
    };
    return SomeMetadata;
})();
var SomeInitialValue = /* #__PURE__ */ (function () {
    function SomeInitialValue(value0) {
        this.value0 = value0;
    };
    SomeInitialValue.create = function (value0) {
        return new SomeInitialValue(value0);
    };
    return SomeInitialValue;
})();
var RefWithOptions = function (x) {
    return x;
};
var NoMetadata = /* #__PURE__ */ (function () {
    function NoMetadata() {

    };
    NoMetadata.value = new NoMetadata();
    return NoMetadata;
})();
var NoInitializer = /* #__PURE__ */ (function () {
    function NoInitializer() {

    };
    NoInitializer.value = new NoInitializer();
    return NoInitializer;
})();
var NoInitialValue = /* #__PURE__ */ (function () {
    function NoInitialValue() {

    };
    NoInitialValue.value = new NoInitialValue();
    return NoInitialValue;
})();
var NestedMetadata = function (x) {
    return x;
};
var MetadataInitializer = /* #__PURE__ */ (function () {
    function MetadataInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    MetadataInitializer.create = function (value0) {
        return function (value1) {
            return new MetadataInitializer(value0, value1);
        };
    };
    return MetadataInitializer;
})();
var Metadata = function (x) {
    return x;
};
var MappedField = function (x) {
    return x;
};
var InitialValueInitializer = /* #__PURE__ */ (function () {
    function InitialValueInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    InitialValueInitializer.create = function (value0) {
        return function (value1) {
            return new InitialValueInitializer(value0, value1);
        };
    };
    return InitialValueInitializer;
})();
var SomeInitializer = function (x) {
    return x;
};
var EffectInitializer = function (x) {
    return x;
};
var ContextInitializer = /* #__PURE__ */ (function () {
    function ContextInitializer(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    ContextInitializer.create = function (value0) {
        return function (value1) {
            return new ContextInitializer(value0, value1);
        };
    };
    return ContextInitializer;
})();
var mergeRef = function (dictTypeEquals) {
    var to = Type_Equality.to(dictTypeEquals);
    return {
        merge: function (x) {
            return function (ref) {
                return write1(ref)(to(x));
            };
        }
    };
};
var maybeGetMetadataSomeMetad = function (dictIsSymbol) {
    return {
        maybeGetMetadata: function (v) {
            return NoMetadata.value;
        }
    };
};
var maybeGetMetadataNoMetadat = {
    maybeGetMetadata: function (v) {
        return NoMetadata.value;
    }
};
var maybeGetMetadata$primeTrueSome = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGetMetadata'": (function () {
                var $940 = get(Type_Proxy["Proxy"].value);
                return function ($941) {
                    return SomeMetadata.create($940($941));
                };
            })()
        };
    };
};
var maybeGetMetadata$primeFalseNoM = {
    "maybeGetMetadata'": function (v) {
        return NoMetadata.value;
    }
};
var maybeGetInitializer$primeTrue = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGetInitializer'": function (v) {
                return function (label) {
                    return get(label);
                };
            }
        };
    };
};
var maybeGetInitializer$primeFalse = {
    "maybeGetInitializer'": function (v) {
        return function (v1) {
            return function (v2) {
                return NoInitializer.value;
            };
        };
    }
};
var maybeGetInitialValue$primeTrue = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGetInitialValue'": function (v) {
                return function (label) {
                    var $942 = get(label);
                    return function ($943) {
                        return SomeInitialValue.create($942($943));
                    };
                };
            }
        };
    };
};
var maybeGetInitialValue$primeFals = {
    "maybeGetInitialValue'": function (v) {
        return function (v1) {
            return function (v2) {
                return NoInitialValue.value;
            };
        };
    }
};
var isRefLikeRef = {
    readRefLike: /* #__PURE__ */ (function () {
        var $944 = map(Data_Maybe.Just.create);
        return function ($945) {
            return $944(Specular_Ref.value($945));
        };
    })(),
    writeRefLike: function (ref) {
        return function (v) {
            if (v instanceof Valid) {
                return write1(ref)(v.value0.value);
            };
            return pure(Data_Unit.unit);
        };
    },
    touchRefLike: function (v) {
        return pure(Data_Unit.unit);
    }
};
var initializeRecordNil = {
    makeRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return function (v3) {
                    return function (v4) {
                        return function (v5) {
                            return pure1(identity);
                        };
                    };
                };
            };
        };
    }
};
var hasOptionsSet = {};
var hasOptionsMultiSet = {};
var hasOptionsMaybeSet = {};
var hasOptionsMaybeMultiSet = {};
var hasOptionsMaybeArray = {};
var hasOptionsArray = {};
var hasOptions = {};
var hasLabelRef = {
    getLabel: function (v) {
        return pure2(Data_Maybe.Nothing.value);
    }
};
var hasLabelFormField = {
    getLabel: function (v) {
        return pure2(Data_Maybe.Nothing.value);
    }
};
var hasFieldIdWithId = {
    getFieldId: function (v) {
        return v.value0.id;
    }
};
var hasFieldIdString = {
    getFieldId: identity1
};
var hasFieldIdRef = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdFunctionEffect = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdFormField = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdEffect = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasFieldIdChoiceRef = function () {
    return {
        getFieldId: function (v) {
            return "";
        }
    };
};
var hasErrorsRef = {
    displayedErrors: function (v) {
        return pure2([  ]);
    }
};
var hasErrorsChoiceRef = {
    displayedErrors: function (v) {
        return pure2([  ]);
    }
};
var hasContextRefContext = {
    getContext: Specular_Ref.value
};
var hasContextContext = {
    getContext: pure2
};
var containerSet = function (dictOrd) {
    var monoidSet = Data_Set_Serialized.monoidSet(dictOrd);
    return {
        fromArray: (function () {
            var $946 = fromFoldable(dictOrd);
            return function ($947) {
                return wrap($946($947));
            };
        })(),
        toArray: function ($948) {
            return toUnfoldable(unwrap($948));
        },
        Monoid0: function () {
            return monoidSet;
        }
    };
};
var containerArray = {
    fromArray: identity1,
    toArray: identity1,
    Monoid0: function () {
        return Data_Monoid.monoidArray;
    }
};
var addErrorsRecordNil = {
    addErrorsRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var addContextRef = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextFormField = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextEffect = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContextDynamic = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var writeRefLike = function (dict) {
    return dict.writeRefLike;
};
var writeRef = function () {
    return write1;
};
var writeRef1 = /* #__PURE__ */ writeRef();
var isTextFieldFormFieldStrin = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef1(Specular_FormField.editRef(f))(value);
            },
            onTouch: triggerCallback(Specular_FormField.focusOutCallback(f))(Data_Unit.unit),
            displayedValue: Specular_Ref.value(Specular_FormField.editRef(f)),
            placeholder: pure2("")
        };
    }
};
var isTextFieldRefString = {
    textInput: function (f) {
        return {
            onChange: function (value) {
                return writeRef1(f)(value);
            },
            onTouch: pure(Data_Unit.unit),
            displayedValue: Specular_Ref.value(f),
            placeholder: pure2("")
        };
    }
};
var withMetadata = /* #__PURE__ */ (function () {
    return MetadataInitializer.create;
})();
var withInitialValue = /* #__PURE__ */ (function () {
    return InitialValueInitializer.create;
})();
var withId = function (id) {
    return function (field) {
        return new WithId({
            id: id,
            field: field
        });
    };
};
var withFinal_ = function (dictMonadReplace) {
    var withDynamic_ = Specular_FRP_Replaceable.withDynamic_(dictMonadReplace);
    return function (dictMonadFRP) {
        var withDynamic_1 = withDynamic_(dictMonadFRP);
        var traverse_ = Data_Foldable.traverse_(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Foldable.foldableMaybe);
        return function (f) {
            return function (block) {
                return withDynamic_1(Restaumatic_Form_Final.unFinal(f))(traverse_(block));
            };
        };
    };
};
var withEffect = EffectInitializer;
var withContext = /* #__PURE__ */ (function () {
    return ContextInitializer.create;
})();
var validateWhenJust = function (validation) {
    return function (paramF) {
        return function (value) {
            return bindFinal(paramF)(function (v) {
                if (v instanceof Data_Maybe.Nothing) {
                    return pure3([  ]);
                };
                if (v instanceof Data_Maybe.Just) {
                    return validation(pure3(v.value0))(value);
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 760, column 3 - line 762, column 48): " + [ v.constructor.name ]);
            });
        };
    };
};
var validateTrue = /* #__PURE__ */ map1(function (v) {
    return mwhen(v === false)([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var validateJust = function (validation) {
    return function (value) {
        return bindFinal(value)(function (v) {
            if (v instanceof Data_Maybe.Just) {
                return validation(pure3(v.value0));
            };
            if (v instanceof Data_Maybe.Nothing) {
                return pure3([  ]);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 725, column 51 - line 727, column 21): " + [ v.constructor.name ]);
        });
    };
};
var validateJustIf = function (v) {
    return function (v1) {
        return function (v2) {
            if (!v) {
                return pure3([  ]);
            };
            if (v) {
                return validateJust(v1)(v2);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 729, column 1 - line 729, column 76): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var unFinalWithDefault = function (def) {
    var $949 = map(Data_Maybe.fromMaybe(def));
    return function ($950) {
        return $949(Restaumatic_Form_Final.unFinal($950));
    };
};
var unFinalFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return bind(Specular_Ref.value(ctxRef))(function (context) {
                return Data_Maybe.maybe(pure2(d))(unFinalWithDefault(d))(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var touchRefLike = function (dict) {
    return dict.touchRefLike;
};
var toRecord = function (dict) {
    return dict.toRecord;
};
var toArray = function (dict) {
    return dict.toArray;
};
var textInput = function (dict) {
    return dict.textInput;
};
var isTextFieldWithId = function (dictIsTextField) {
    var textInput1 = textInput(dictIsTextField);
    return {
        textInput: function (v) {
            return textInput1(v.value0.field);
        }
    };
};
var tagErrors = function (fieldName) {
    return function (label) {
        return function (errors) {
            return wrap((function () {
                var v = lookup(Data_Maybe.Nothing.value)(unwrap(errors));
                if (v instanceof Data_Maybe.Just) {
                    return insertWith(append)(new Data_Maybe.Just(fieldName))(mapFlipped(v.value0)(function (error) {
                        var $681 = {};
                        for (var $682 in error) {
                            if ({}.hasOwnProperty.call(error, $682)) {
                                $681[$682] = error[$682];
                            };
                        };
                        $681.fieldName = new Data_Maybe.Just(fieldName);
                        $681.fieldLabel = label;
                        return $681;
                    }));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return identity1;
                };
                throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 612, column 9 - line 615, column 30): " + [ v.constructor.name ]);
            })()($$delete(Data_Maybe.Nothing.value)(unwrap(errors))));
        };
    };
};
var singleOption = function (label) {
    return function (key) {
        return new Specular_Select.SingleOption({
            label: label,
            key: key,
            disabled: false
        });
    };
};
var withNothing = function (emptyLabel) {
    return function (opts) {
        return append([ singleOption(emptyLabel)(Data_Maybe.Nothing.value) ])(map2(map3(Data_Maybe.Just.create))(opts));
    };
};
var withOptions = function (field) {
    return function (label) {
        return {
            field: field,
            toOption: function (a) {
                return singleOption(label(a))(a);
            }
        };
    };
};
var shorterThan = /* #__PURE__ */ lift2(function (threshold) {
    return function (value) {
        return munless(Data_String_CodePoints.length(value) <= threshold)([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.shorterThan)({
            threshold: show(threshold)
        }) ]);
    };
});
var selectWriteValue = function (dict) {
    return dict.selectWriteValue;
};
var selectTouch = function (dict) {
    return dict.selectTouch;
};
var selectReadValue = function (dict) {
    return dict.selectReadValue;
};
var selectGetOptions = function (dict) {
    return dict.selectGetOptions;
};
var selectInput = function (dictEq) {
    var containsKey = Specular_Select.containsKey(dictEq);
    return function (dictIsSelectField) {
        var selectWriteValue1 = selectWriteValue(dictIsSelectField);
        var selectReadValue1 = selectReadValue(dictIsSelectField);
        var selectGetOptions1 = selectGetOptions(dictIsSelectField);
        var selectTouch1 = selectTouch(dictIsSelectField);
        return function (field) {
            var extraOption = function (stdOptions) {
                return function (value) {
                    if (value instanceof Data_Maybe.Just && Data_Array.any(containsKey(value.value0))(stdOptions)) {
                        return [  ];
                    };
                    if (value instanceof Data_Maybe.Just) {
                        return [ new Specular_Select.SingleOption({
                            key: new Data_Maybe.Just(value.value0),
                            label: "",
                            disabled: false
                        }) ];
                    };
                    if (value instanceof Data_Maybe.Nothing) {
                        return [ new Specular_Select.SingleOption({
                            key: Data_Maybe.Nothing.value,
                            label: "",
                            disabled: false
                        }) ];
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1030, column 5 - line 1036, column 70): " + [ value.constructor.name ]);
                };
            };
            return {
                onChange: function (v) {
                    if (v instanceof Data_Maybe.Just) {
                        return selectWriteValue1(field)(v.value0);
                    };
                    if (v instanceof Data_Maybe.Nothing) {
                        return pure(Data_Unit.unit);
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1015, column 7 - line 1020, column 20): " + [ v.constructor.name ]);
                },
                displayedValue: map(Data_Maybe.Just.create)(selectReadValue1(field)),
                displayedOptions: apply(map(function (v) {
                    return function (v1) {
                        return append(extraOption(v)(v1))(map2(map3(Data_Maybe.Just.create))(v));
                    };
                })(selectGetOptions1(field)))(selectReadValue1(field)),
                onTouch: selectTouch1(field)
            };
        };
    };
};
var isSelectFieldWithId = function (dictIsSelectField) {
    var selectWriteValue1 = selectWriteValue(dictIsSelectField);
    var selectReadValue1 = selectReadValue(dictIsSelectField);
    var selectGetOptions1 = selectGetOptions(dictIsSelectField);
    var selectTouch1 = selectTouch(dictIsSelectField);
    return {
        selectWriteValue: function (v) {
            return selectWriteValue1(v.value0.field);
        },
        selectReadValue: function (v) {
            return selectReadValue1(v.value0.field);
        },
        selectGetOptions: function (v) {
            return selectGetOptions1(v.value0.field);
        },
        selectTouch: function (v) {
            return selectTouch1(v.value0.field);
        }
    };
};
var requiredError = function (v) {
    return Restaumatic_Form_Errors.userVisibleError(Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required));
};
var readRefLike = function (dict) {
    return dict.readRefLike;
};
var isRefLikeFormField = {
    readRefLike: /* #__PURE__ */ (function () {
        var $951 = readRefLike(isRefLikeRef);
        return function ($952) {
            return $951(Specular_FormField.editRef($952));
        };
    })(),
    writeRefLike: /* #__PURE__ */ (function () {
        var $953 = writeRefLike(isRefLikeRef);
        return function ($954) {
            return $953(Specular_FormField.editRef($954));
        };
    })(),
    touchRefLike: function (field) {
        return Specular_FormField.focusOutCallback(field)(Data_Unit.unit);
    }
};
var isRefLikeWithId = function (dictIsRefLike) {
    var writeRefLike1 = writeRefLike(dictIsRefLike);
    var readRefLike1 = readRefLike(dictIsRefLike);
    var touchRefLike1 = touchRefLike(dictIsRefLike);
    return {
        writeRefLike: function (v) {
            return writeRefLike1(v.value0.field);
        },
        readRefLike: function (v) {
            return readRefLike1(v.value0.field);
        },
        touchRefLike: function (v) {
            return touchRefLike1(v.value0.field);
        }
    };
};
var optionForEq = function () {
    return Unsafe_Coerce.unsafeCoerce;
};
var nonEmpty = /* #__PURE__ */ map1(function (s) {
    return mwhen(s === "")([ Restaumatic_I18n.translate_(Restaumatic_Common_Translations_Keys.t.form.errors.required) ]);
});
var modifyRefLike = function (dictMonadEffect) {
    var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
    return function (dictIsRefLike) {
        var readRefLike1 = readRefLike(dictIsRefLike);
        var writeRefLike1 = writeRefLike(dictIsRefLike);
        return function (field) {
            return function (fn) {
                return liftEffect1(function __do() {
                    var m_value = readDynamic(readRefLike1(field))();
                    return for_(m_value)(function (value) {
                        return writeRefLike1(field)(new Valid({
                            value: fn(value),
                            editValue: Data_Maybe.Nothing.value
                        }));
                    })();
                });
            };
        };
    };
};
var metaLabel = function (label) {
    return {
        label: new Data_Maybe.Just(label),
        options: Data_Maybe.Nothing.value
    };
};
var mergeUnit = function (dictTypeEquals) {
    return {
        merge: function (v) {
            return function (v1) {
                return pure(Data_Unit.unit);
            };
        }
    };
};
var mergeRecordNil = {
    mergeRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var mergeRecord = function (dict) {
    return dict.mergeRecord;
};
var merge_Record = function (dictAsRecord) {
    var toRecord1 = toRecord(dictAsRecord);
    return function () {
        return function (dictMergeRecord) {
            var mergeRecord1 = mergeRecord(dictMergeRecord);
            return {
                merge: function (d) {
                    return function (f) {
                        return mergeRecord1(Type_Proxy["Proxy"].value)(toRecord1(d))(f);
                    };
                }
            };
        };
    };
};
var mergeInputRequired = function (dict) {
    return dict.mergeInputRequired;
};
var merge = function (dict) {
    return dict.merge;
};
var mergeRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictMergeRecord) {
        var mergeRecord1 = mergeRecord(dictMergeRecord);
        return function (dictMerge) {
            var merge1 = merge(dictMerge);
            return function () {
                return function () {
                    return function () {
                        return function () {
                            return {
                                mergeRecord: function (v) {
                                    return function (r) {
                                        return function (f) {
                                            return function __do() {
                                                measure("merge " + reflectSymbol(Type_Proxy["Proxy"].value))(merge1(get(Type_Proxy["Proxy"].value)(r))(get(Type_Proxy["Proxy"].value)(f)))();
                                                return mergeRecord1(Type_Proxy["Proxy"].value)(r)(f)();
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var write = function (dictMerge) {
    var merge1 = merge(dictMerge);
    return function (dictMonadEffect) {
        var liftEffect1 = Effect_Class.liftEffect(dictMonadEffect);
        return function (field) {
            return function (value) {
                return liftEffect1(merge1(value)(field));
            };
        };
    };
};
var mergeChoiceRef = function (dictTypeEquals) {
    var merge1 = merge(mergeRef(dictTypeEquals));
    return {
        merge: function (x) {
            return function (ref) {
                return merge1(x)(Specular_ChoiceRef.currentChoice(ref));
            };
        }
    };
};
var mergeDelayed = function (dictMerge) {
    var merge1 = merge(dictMerge);
    return {
        merge: function (x) {
            return function (v) {
                return function __do() {
                    var field = readDynamic(v)();
                    return merge1(x)(field)();
                };
            };
        }
    };
};
var mergeT2T2 = function (dictMerge) {
    var merge1 = merge(dictMerge);
    return function (dictMerge1) {
        var merge2 = merge(dictMerge1);
        return {
            merge: function (v) {
                return function (v1) {
                    return function __do() {
                        merge1(v.value0)(v1.value0)();
                        return merge2(v.value1)(v1.value1)();
                    };
                };
            }
        };
    };
};
var maybeGetMetadata$prime = function (dict) {
    return dict["maybeGetMetadata'"];
};
var maybeGetMetadataSomeMetad1 = function () {
    return function (dictMaybeGetMetadata$prime) {
        var maybeGetMetadata$prime1 = maybeGetMetadata$prime(dictMaybeGetMetadata$prime);
        return {
            maybeGetMetadata: function (v) {
                return maybeGetMetadata$prime1(v.value0);
            }
        };
    };
};
var maybeGetMetadataSomeMetad2 = function (dictIsSymbol) {
    return function () {
        return function (dictMaybeGetMetadata$prime) {
            var maybeGetMetadata$prime1 = maybeGetMetadata$prime(dictMaybeGetMetadata$prime);
            return {
                maybeGetMetadata: function (v) {
                    return maybeGetMetadata$prime1(v.value0.nested);
                }
            };
        };
    };
};
var maybeGetMetadata = function (dict) {
    return dict.maybeGetMetadata;
};
var maybeGetInitializer$prime = function (dict) {
    return dict["maybeGetInitializer'"];
};
var maybeGetInitializer1 = function () {
    return function (dictMaybeGetInitializer$prime) {
        return {
            maybeGetInitializer: maybeGetInitializer$prime(dictMaybeGetInitializer$prime)(Type_Proxy["Proxy"].value)
        };
    };
};
var maybeGetInitializer = function (dict) {
    return dict.maybeGetInitializer;
};
var maybeGetInitialValue$prime = function (dict) {
    return dict["maybeGetInitialValue'"];
};
var maybeGetInitialValue1 = function () {
    return function (dictMaybeGetInitialValue$prime) {
        return {
            maybeGetInitialValue: maybeGetInitialValue$prime(dictMaybeGetInitialValue$prime)(Type_Proxy["Proxy"].value)
        };
    };
};
var maybeGetInitialValue = function (dict) {
    return dict.maybeGetInitialValue;
};
var maybeContainerToArray = function (dictContainer) {
    var toArray1 = toArray(dictContainer);
    return function (v) {
        if (v instanceof Data_Maybe.Nothing) {
            return mempty;
        };
        if (v instanceof Data_Maybe.Just) {
            return toArray1(v.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 1001, column 1 - line 1001, column 73): " + [ v.constructor.name ]);
    };
};
var mapVFinal = function (f) {
    var $955 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f));
    return function ($956) {
        return Restaumatic_Form_Final.makeFinalV($955(Restaumatic_Form_Final.unFinalV($956)));
    };
};
var mapMaybeFinalUserVisible = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.userVisibleError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return pure4(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 578, column 5 - line 580, column 23): " + [ v.constructor.name ]);
        };
        var $957 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($958) {
            return Restaumatic_Form_Final.makeFinalV($957(Restaumatic_Form_Final.unFinalV($958)));
        };
    };
};
var mapMaybeFinalInternal = function (errorMessage) {
    return function (f) {
        var f$prime = function (x) {
            var v = f(x);
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.internalError(errorMessage));
            };
            if (v instanceof Data_Maybe.Just) {
                return pure4(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 588, column 5 - line 590, column 23): " + [ v.constructor.name ]);
        };
        var $959 = map(Data_Validation_Semigroup.validation(Data_Validation_Semigroup.invalid)(f$prime));
        return function ($960) {
            return Restaumatic_Form_Final.makeFinalV($959(Restaumatic_Form_Final.unFinalV($960)));
        };
    };
};
var mapMaybeFinal = /* #__PURE__ */ mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
var mapDynamicFinal = function (f) {
    return function ($961) {
        return Restaumatic_Form_Final.makeFinalV((function (v) {
            return bind(v)(traverse(f));
        })(Restaumatic_Form_Final.unFinalV($961)));
    };
};
var makeWithSomeInitializer = function (v) {
    return function (opts) {
        return function (meta) {
            return function (iv) {
                return function (v1) {
                    return v1(opts)(meta)(iv);
                };
            };
        };
    };
};
var initializeSomeInitializer = {
    makeImpl: makeWithSomeInitializer
};
var makeWithMetadataInitializer = function (dict) {
    return dict.makeWithMetadataInitializer;
};
var initializeMetadataInitial = function (dictMakeWithMetadataInitializer) {
    return {
        makeImpl: makeWithMetadataInitializer(dictMakeWithMetadataInitializer)
    };
};
var makeWithInitialValueInitializer = function (dict) {
    return dict.makeWithInitialValueInitializer;
};
var initializeInitialValueIni = function (dictMakeWithInitialValueInitializer) {
    return {
        makeImpl: makeWithInitialValueInitializer(dictMakeWithInitialValueInitializer)
    };
};
var makeRecordImpl = function (dict) {
    return dict.makeRecordImpl;
};
var initializeSomeInitialValu = function (dictAsRecord) {
    var toRecord1 = toRecord(dictAsRecord);
    return function () {
        return function (dictInitializeRecord) {
            var makeRecordImpl1 = makeRecordImpl(dictInitializeRecord);
            return {
                makeImpl: function (p) {
                    return function (opts) {
                        return function (meta) {
                            return function (v) {
                                return function (i) {
                                    return map4(Record_Builder.buildFromScratch)(makeRecordImpl1(Type_Proxy["Proxy"].value)(p)(opts)(meta)(toRecord1(v.value0))(i));
                                };
                            };
                        };
                    };
                }
            };
        };
    };
};
var makeImpl = function (dict) {
    return dict.makeImpl;
};
var makeWithDefaultInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (defaultInitializer) {
        return function (p) {
            return function (opts) {
                return function (meta) {
                    return function (iv) {
                        return function (v) {
                            return makeImpl1(p)(opts)(meta)(iv)(defaultInitializer);
                        };
                    };
                };
            };
        };
    };
};
var initializeNoInitializerRe = function (dictInitialize) {
    return {
        makeImpl: makeWithDefaultInitializer(dictInitialize)({})
    };
};
var makeWithEffectInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (p) {
        return function (opts) {
            return function (meta) {
                return function (iv) {
                    return function (v) {
                        return bind2(v)(function (initializer) {
                            return makeImpl1(p)(opts)(meta)(iv)(initializer);
                        });
                    };
                };
            };
        };
    };
};
var initializeEffectInitializ = function (dictInitialize) {
    return {
        makeImpl: makeWithEffectInitializer(dictInitialize)
    };
};
var someInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (initializer) {
        return function (opts) {
            return function (meta) {
                return function (iv) {
                    return makeImpl1(Type_Proxy["Proxy"].value)(opts)(meta)(iv)(initializer);
                };
            };
        };
    };
};
var initializeNoInitialValueR = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeImpl: function (p) {
            return function (opts) {
                return function (meta) {
                    return function (v) {
                        return makeImpl1(p)(opts)(meta)(new SomeInitialValue({}));
                    };
                };
            };
        }
    };
};
var initializeNoInitialValueT = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl2 = makeImpl(dictInitialize1);
        return {
            makeImpl: function (v) {
                return function (opts) {
                    return function (v1) {
                        return function (v2) {
                            return function (v3) {
                                return apply1(map4(Data_Tuple_T2.T2.create)(makeImpl1(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_0" ])
                                })(v1.value0)(NoInitialValue.value)(v3.value0)))(makeImpl2(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_1" ])
                                })(v1.value1)(NoInitialValue.value)(v3.value1));
                            };
                        };
                    };
                };
            }
        };
    };
};
var initializeNoInitialValueT1 = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl2 = makeImpl(dictInitialize1);
        return {
            makeImpl: function (v) {
                return function (opts) {
                    return function (v1) {
                        return function (v2) {
                            return function (v3) {
                                return apply1(map4(Data_Tuple_T2.T2.create)(makeImpl1(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_0" ])
                                })(NoMetadata.value)(NoInitialValue.value)(v3.value0)))(makeImpl2(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_1" ])
                                })(NoMetadata.value)(NoInitialValue.value)(v3.value1));
                            };
                        };
                    };
                };
            }
        };
    };
};
var initializeRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var insert1 = insert(dictIsSymbol);
    return function (dictInitializeRecord) {
        var makeRecordImpl1 = makeRecordImpl(dictInitializeRecord);
        return function (dictMaybeGetInitialValue) {
            var maybeGetInitialValue2 = maybeGetInitialValue(dictMaybeGetInitialValue);
            return function (dictMaybeGetInitializer) {
                var maybeGetInitializer2 = maybeGetInitializer(dictMaybeGetInitializer);
                return function (dictMaybeGetMetadata) {
                    var maybeGetMetadata1 = maybeGetMetadata(dictMaybeGetMetadata);
                    return function (dictInitialize) {
                        var makeImpl1 = makeImpl(dictInitialize);
                        return function () {
                            return function () {
                                return {
                                    makeRecordImpl: function (v) {
                                        return function (p) {
                                            return function (opts) {
                                                return function (meta) {
                                                    return function (ivs) {
                                                        return function (is) {
                                                            return bind2(makeImpl1(Type_Proxy["Proxy"].value)({
                                                                name: append(opts.name)([ reflectSymbol(Type_Proxy["Proxy"].value) ])
                                                            })(maybeGetMetadata1(meta))(maybeGetInitialValue2(Type_Proxy["Proxy"].value)(ivs))(maybeGetInitializer2(Type_Proxy["Proxy"].value)(is)))(function (x) {
                                                                return bind2(makeRecordImpl1(Type_Proxy["Proxy"].value)(p)(opts)(meta)(ivs)(is))(function (xs) {
                                                                    return pure1(composeFlipped(xs)(insert1(Type_Proxy["Proxy"].value)(x)));
                                                                });
                                                            });
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    }
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var initializeSomeInitialValu1 = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictInitialize1) {
        var makeImpl2 = makeImpl(dictInitialize1);
        return {
            makeImpl: function (v) {
                return function (opts) {
                    return function (v1) {
                        return function (v2) {
                            return function (v3) {
                                return apply1(map4(Data_Tuple_T2.T2.create)(makeImpl1(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_0" ])
                                })(v1.value0)(new SomeInitialValue(v2.value0.value0))(v3.value0)))(makeImpl2(Type_Proxy["Proxy"].value)({
                                    name: append(opts.name)([ "_1" ])
                                })(v1.value1)(new SomeInitialValue(v2.value0.value1))(v3.value1));
                            };
                        };
                    };
                };
            }
        };
    };
};
var makeWithInitialValueIniti = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeWithInitialValueInitializer: function (p) {
            return function (opts) {
                return function (meta) {
                    return function (v) {
                        return function (v1) {
                            return makeImpl1(p)(opts)(meta)(new SomeInitialValue(v1.value0))(v1.value1);
                        };
                    };
                };
            };
        }
    };
};
var makeWithInitialValueIniti1 = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeWithInitialValueInitializer: function (p) {
            return function (opts) {
                return function (meta) {
                    return function (given_iv) {
                        return function (v) {
                            return makeImpl1(p)(opts)(meta)(given_iv)(v.value1);
                        };
                    };
                };
            };
        }
    };
};
var makeWithMetadataInitializ = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return {
        makeWithMetadataInitializer: function (p) {
            return function (opts) {
                return function (v) {
                    return function (iv) {
                        return function (v1) {
                            return makeImpl1(p)(opts)(new SomeMetadata(v1.value0))(iv)(v1.value1);
                        };
                    };
                };
            };
        }
    };
};
var make = function (dictMonadFRP) {
    var liftHost = Specular_FRP_Host.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0());
    return function (dictInitialize) {
        var makeImpl1 = makeImpl(dictInitialize);
        return function (name) {
            return function (f) {
                return liftHost(fixDelayed(function (delayed) {
                    return makeImpl1(Type_Proxy["Proxy"].value)({
                        name: name
                    })(NoMetadata.value)(NoInitialValue.value)(f(delayed));
                }));
            };
        };
    };
};
var mSelectWriteValue = function (dict) {
    return dict.mSelectWriteValue;
};
var mSelectTouch = function (dict) {
    return dict.mSelectTouch;
};
var mSelectReadValue = function (dict) {
    return dict.mSelectReadValue;
};
var mSelectGetOptions = function (dict) {
    return dict.mSelectGetOptions;
};
var isMultiSelectFieldWithId = function (dictIsMultiSelectField) {
    var mSelectWriteValue1 = mSelectWriteValue(dictIsMultiSelectField);
    var mSelectReadValue1 = mSelectReadValue(dictIsMultiSelectField);
    var mSelectGetOptions1 = mSelectGetOptions(dictIsMultiSelectField);
    var mSelectTouch1 = mSelectTouch(dictIsMultiSelectField);
    return {
        mSelectWriteValue: function (v) {
            return mSelectWriteValue1(v.value0.field);
        },
        mSelectReadValue: function (v) {
            return mSelectReadValue1(v.value0.field);
        },
        mSelectGetOptions: function (v) {
            return mSelectGetOptions1(v.value0.field);
        },
        mSelectTouch: function (v) {
            return mSelectTouch1(v.value0.field);
        }
    };
};
var liftMaybe = function ($962) {
    return Restaumatic_Form_Final.makeFinal(pure2($962));
};
var lessThanOrEqual = function (dictOrd) {
    var lessThanOrEq1 = Data_Ord.lessThanOrEq(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(lessThanOrEq1(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThanOrEqual)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var lessThan = function (dictOrd) {
    var lessThan1 = Data_Ord.lessThan(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(lessThan1(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.lessThan)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var isSelectFieldRefWithOptions = function (dictIsRefLike) {
    var writeRefLike1 = writeRefLike(dictIsRefLike);
    var readRefLike1 = readRefLike(dictIsRefLike);
    var touchRefLike1 = touchRefLike(dictIsRefLike);
    return {
        selectWriteValue: function (v) {
            return function (value) {
                return writeRefLike1(v.field)(new Valid({
                    value: value,
                    editValue: Data_Maybe.Nothing.value
                }));
            };
        },
        selectReadValue: function (v) {
            return readRefLike1(v.field);
        },
        selectGetOptions: function (v) {
            return v.choices;
        },
        selectTouch: function (v) {
            return touchRefLike1(v.field);
        }
    };
};
var isSelectFieldChoiceRef = {
    selectWriteValue: function (v) {
        return function (a) {
            return write1(v.field.currentChoice)(a);
        };
    },
    selectReadValue: function (v) {
        return map(Data_Maybe.Just.create)(Specular_Ref.value(Specular_ChoiceRef.currentChoice(v.field)));
    },
    selectGetOptions: function (v) {
        return map(map2(v.toOption))(Specular_ChoiceRef.choices(v.field));
    },
    selectTouch: function (v) {
        return pure(Data_Unit.unit);
    }
};
var isMultiSelectFieldMultiChoiceRef = {
    mSelectWriteValue: function (v) {
        return function (a) {
            return updateRef(v.field.currentChoices)(a);
        };
    },
    mSelectReadValue: function (v) {
        return Specular_Ref.value(Specular_MultiChoiceRef.currentChoices(v.field));
    },
    mSelectGetOptions: function (v) {
        return map(map2(v.toOption))(Specular_MultiChoiceRef.choices(v.field));
    },
    mSelectTouch: function (v) {
        return pure(Data_Unit.unit);
    }
};
var initializerFor = function (dictInitialize) {
    return identity1;
};
var hasErrorsOldFormField = {
    displayedErrors: Specular_FormField.displayedErrors
};
var hasErrorsErrorArray = {
    displayedErrors: /* #__PURE__ */ unFinalWithDefault(mempty)
};
var greaterThanOrEqualFmt = function (dictOrd) {
    var greaterThanOrEq = Data_Ord.greaterThanOrEq(dictOrd);
    return function (display) {
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThanOrEq(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThanOrEqual)({
                    threshold: display(threshold)
                }) ]);
            };
        });
    };
};
var greaterThanOrEqual = function (dictOrd) {
    var greaterThanOrEq = Data_Ord.greaterThanOrEq(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThanOrEq(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThanOrEqual)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var greaterThan = function (dictOrd) {
    var greaterThan2 = Data_Ord.greaterThan(dictOrd);
    return function (dictShow) {
        var show1 = Data_Show.show(dictShow);
        return lift2(function (threshold) {
            return function (value) {
                return munless(greaterThan2(value)(threshold))([ Restaumatic_I18n.translate(Restaumatic_Common_Translations_Keys.t.form.errors.greaterThan)({
                    threshold: show1(threshold)
                }) ]);
            };
        });
    };
};
var getLabel = function (dict) {
    return dict.getLabel;
};
var hasLabelMappedField = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.field);
        }
    };
};
var hasLabelRefWithOptions = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.field);
        }
    };
};
var hasLabelWithId = function (dictHasLabel) {
    var getLabel1 = getLabel(dictHasLabel);
    return {
        getLabel: function (v) {
            return getLabel1(v.value0.field);
        }
    };
};
var getFieldId = function (dict) {
    return dict.getFieldId;
};
var hasFieldIdRefWithOptions = function (dictHasFieldId) {
    var getFieldId1 = getFieldId(dictHasFieldId);
    return {
        getFieldId: function (v) {
            return getFieldId1(v.field);
        }
    };
};
var hasFieldIdWithOptions = function (dictHasFieldId) {
    var getFieldId1 = getFieldId(dictHasFieldId);
    return {
        getFieldId: function (v) {
            return getFieldId1(v.field);
        }
    };
};
var getContext = function (dict) {
    return dict.getContext;
};
var unFinalFromContext = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return function (key) {
        return function (field) {
            return bind(getContext1(field))(function (ctx) {
                return Data_Maybe.maybe(pure2(Data_Maybe.Nothing.value))(Restaumatic_Form_Final.unFinal)(Data_Vault.lookup(key)(ctx));
            });
        };
    };
};
var hasContextDelayed = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return {
        getContext: function (v) {
            return bind(v)(getContext1);
        }
    };
};
var hasContextWithId = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return {
        getContext: function (v) {
            return getContext1(v.value0.field);
        }
    };
};
var genericTypedValue = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Undefined(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Invalid(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return new Valid(x.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 77, column 1 - line 77, column 64): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Undefined) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Invalid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Valid) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Internal (line 77, column 1 - line 77, column 64): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericTypedValue);
var defaultEncode = /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericTypedValue);
var showTypedValue = function (dictShow) {
    var showRecordFieldsConsNil2 = showRecordFieldsConsNil(Restaumatic_Form_Value.showValue(dictShow));
    return {
        show: genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsConsNil2)))(UndefinedIsSymbol))(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsCons1(showRecordFieldsConsNil2)(Restaumatic_Form_Errors.showFormErrors))(showMaybe))))(InvalidIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showRecord(showRecordFieldsCons(showRecordFieldsConsNil1(dictShow))(showMaybe))))(ValidIsSymbol))))
    };
};
var fromRecord = function (dict) {
    return dict.fromRecord;
};
var fromChoices = function (dictFoldable) {
    var fromFoldable2 = Data_Array.fromFoldable(dictFoldable);
    return function (dictIsRefLike) {
        return function (field) {
            return function (cs) {
                return {
                    field: field,
                    choices: mapFlipped1(mapFlipped1(cs)(fromFoldable2))(map2(function (r) {
                        return singleOption(r.name)(r.id);
                    }))
                };
            };
        };
    };
};
var fromArray = function (dict) {
    return dict.fromArray;
};
var containerMaybe = function (dictContainer) {
    var fromArray1 = fromArray(dictContainer);
    var monoidMaybe = Data_Maybe.monoidMaybe((dictContainer.Monoid0()).Semigroup0());
    return {
        fromArray: function (v) {
            if (v.length === 0) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(fromArray1(v));
        },
        toArray: Data_Maybe.maybe([  ])(toArray(dictContainer)),
        Monoid0: function () {
            return monoidMaybe;
        }
    };
};
var isMultiSelectFieldRefWith = function (dictContainer) {
    var fromArray1 = fromArray(dictContainer);
    var maybeContainerToArray1 = maybeContainerToArray(dictContainer);
    return function (dictIsRefLike) {
        var writeRefLike1 = writeRefLike(dictIsRefLike);
        var readRefLike1 = readRefLike(dictIsRefLike);
        return {
            mSelectWriteValue: function (v) {
                return function (value) {
                    return writeRefLike1(v.field)(new Valid({
                        value: fromArray1(value),
                        editValue: Data_Maybe.Nothing.value
                    }));
                };
            },
            mSelectReadValue: function (v) {
                return map(maybeContainerToArray1)(readRefLike1(v.field));
            },
            mSelectGetOptions: function (v) {
                return v.choices;
            },
            mSelectTouch: function (v) {
                return pure(Data_Unit.unit);
            }
        };
    };
};
var forceDisplayErrorsKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var forceDisplayErrors = /* #__PURE__ */ Data_Vault.singleton(forceDisplayErrorsKey);
var fieldPathToString = /* #__PURE__ */ Data_String_Common.joinWith(".");
var failFirst = function (validations_) {
    return function (value) {
        return bindFinal(value)(function (value_) {
            var validationValuesD = map2((function () {
                var $963 = map(Data_Maybe.fromMaybe([  ]));
                return function ($964) {
                    return $963(Restaumatic_Form_Final.unFinal((function (v) {
                        return v(pure3(value_));
                    })($964)));
                };
            })())(validations_);
            var validationValues = sequence(validationValuesD);
            var findFirst = (function () {
                var $965 = Data_Maybe.fromMaybe([  ]);
                var $966 = find(function (e) {
                    return length(e) > 0;
                });
                return function ($967) {
                    return $965($966($967));
                };
            })();
            var result = map(function ($968) {
                return Data_Maybe.Just.create(findFirst($968));
            })(validationValues);
            return Restaumatic_Form_Final.makeFinal(result);
        });
    };
};
var encodeTypedValue = function (dictEncode) {
    var encodeRecordCons4 = encodeRecordCons2(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Form_Value.encodeValue(dictEncode)));
    var genericEncodeSum = Foreign_Generic_Class.genericEncodeSum(genericEncodeConstructor(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons4))));
    var genericEncodeSum1 = Foreign_Generic_Class.genericEncodeSum(genericEncodeConstructor1(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons(encodeRecordCons4)(errorIsSymbol)(encodeWithOptionsOther))(editValueIsSymbol)(encodeWithOptionsOther1)))));
    return function (dictEncodeWithOptions) {
        return {
            encode: defaultEncode(genericEncodeSum(genericEncodeSum1(genericEncodeConstructor2(Foreign_Generic_Class.genericEncodeArgsRecord(encodeWithOptionsRecord(encodeRecordCons(encodeRecordCons3(dictEncodeWithOptions))(editValueIsSymbol)(encodeWithOptionsOther1)))))))
        };
    };
};
var dynamicFromContextDef = function (d) {
    return function (key) {
        return function (ctxRef) {
            return bind(Specular_Ref.value(ctxRef))(function (context) {
                return Data_Maybe.fromMaybe(pure2(d))(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var dynamicFromContext = function (dictHasContext) {
    var getContext1 = getContext(dictHasContext);
    return function (key) {
        return function (field) {
            return bind(getContext1(field))(function (context) {
                return sequence1(Data_Vault.lookup(key)(context));
            });
        };
    };
};
var dumpStateRecordNil = {
    dumpStateRecord: function (v) {
        return function (v1) {
            return pure2(Foreign_Object.empty);
        };
    }
};
var dumpStateRecord = function (dict) {
    return dict.dumpStateRecord;
};
var dumpState_Record = function () {
    return function (dictDumpStateRecord) {
        return {
            dumpState: (function () {
                var $969 = map(encode);
                var $970 = dumpStateRecord(dictDumpStateRecord)(Type_Proxy["Proxy"].value);
                return function ($971) {
                    return $969($970($971));
                };
            })()
        };
    };
};
var dumpState = function (dict) {
    return dict.dumpState;
};
var dumpStateRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    return function (dictDumpStateRecord) {
        var dumpStateRecord1 = dumpStateRecord(dictDumpStateRecord);
        return function (dictDumpState) {
            var dumpState1 = dumpState(dictDumpState);
            return function () {
                return function () {
                    return {
                        dumpStateRecord: function (v) {
                            return function (f) {
                                return apply(map(function (v1) {
                                    return function (v2) {
                                        return Foreign_Object.insert(reflectSymbol(Type_Proxy["Proxy"].value))(v1)(v2);
                                    };
                                })(dumpState1(get(Type_Proxy["Proxy"].value)(f))))(dumpStateRecord1(Type_Proxy["Proxy"].value)(f));
                            };
                        }
                    };
                };
            };
        };
    };
};
var displayedErrors = function (dict) {
    return dict.displayedErrors;
};
var hasDisplayedErrors = function (dictHasErrors) {
    var $972 = map(function ($975) {
        return !Data_Array["null"]($975);
    });
    var $973 = displayedErrors(dictHasErrors);
    return function ($974) {
        return $972($973($974));
    };
};
var hasErrorsDelayed = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return bind(v)(displayedErrors1);
        }
    };
};
var hasErrorsMappedField = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var hasErrorsRefWithOptions = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var hasErrorsWithId = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.value0.field);
        }
    };
};
var hasErrorsWithOptions = function (dictHasErrors) {
    var displayedErrors1 = displayedErrors(dictHasErrors);
    return {
        displayedErrors: function (v) {
            return displayedErrors1(v.field);
        }
    };
};
var displayLocaleKey = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Data_Vault.newKey);
var displayLocale = /* #__PURE__ */ Data_Vault.singleton(displayLocaleKey);
var copyState = function (dict) {
    return dict.copyState;
};
var asRecordRecord = {
    fromRecord: identity1,
    toRecord: identity1
};
var asRecordNewtype = function () {
    return {
        fromRecord: wrap,
        toRecord: unwrap
    };
};
var annotatedFinal = function (name) {
    var $976 = Specular_FRP_Base.annotated(name);
    return function ($977) {
        return Restaumatic_Form_Final.makeFinalV($976(Restaumatic_Form_Final.unFinalV($977)));
    };
};
var annotateFinal = function (dictMonadEffect) {
    var $978 = Specular_FRP_Base.annotate(dictMonadEffect);
    return function ($979) {
        return $978(Restaumatic_Form_Final.unFinal($979));
    };
};
var addErrorsRecord = function (dict) {
    return dict.addErrorsRecord;
};
var addErrorsRecord1 = function () {
    return function (dictAddErrorsRecord) {
        var addErrorsRecord2 = addErrorsRecord(dictAddErrorsRecord);
        return {
            addErrors: function (errors) {
                return addErrorsRecord2(errors)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var addErrors = function (dict) {
    return dict.addErrors;
};
var addErrorsPrefix = function (dictAddErrors) {
    var addErrors1 = addErrors(dictAddErrors);
    return function (prefix) {
        return function (errors) {
            return function (f) {
                var addPrefix = function (v) {
                    return new Data_Tuple.Tuple(prefix + ("." + v.value0), v.value1);
                };
                var prefixedErrors = fromFoldable1(map2(addPrefix)(toUnfoldable1(errors)));
                return addErrors1(prefixedErrors)(f);
            };
        };
    };
};
var addErrorsRecordCons = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function (dictAddErrorsRecord) {
        var addErrorsRecord2 = addErrorsRecord(dictAddErrorsRecord);
        return function (dictAddErrors) {
            var addErrors1 = addErrors(dictAddErrors);
            return function () {
                return function () {
                    return {
                        addErrorsRecord: function (errors) {
                            return function (v) {
                                return function (f) {
                                    return function __do() {
                                        addErrors1(errors)(get(Type_Proxy["Proxy"].value)(f))();
                                        return addErrorsRecord2(errors)(Type_Proxy["Proxy"].value)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var addContextRecordNil = {
    addContextRecord: function (v) {
        return function (v1) {
            return function (v2) {
                return pure(Data_Unit.unit);
            };
        };
    }
};
var addContextRecord = function (dict) {
    return dict.addContextRecord;
};
var addContext_Record = function () {
    return function (dictAddContextRecord) {
        return {
            addContext: addContextRecord(dictAddContextRecord)(Type_Proxy["Proxy"].value)
        };
    };
};
var addContextMaybe = {
    addContext: function (v) {
        return function (v1) {
            return pure(Data_Unit.unit);
        };
    }
};
var addContext = function (dict) {
    return dict.addContext;
};
var addContextRecordCons = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function (dictAddContextRecord) {
        var addContextRecord1 = addContextRecord(dictAddContextRecord);
        return function (dictAddContext) {
            var addContext1 = addContext(dictAddContext);
            return function () {
                return function () {
                    return {
                        addContextRecord: function (v) {
                            return function (ctx) {
                                return function (f) {
                                    return function __do() {
                                        addContext1(ctx)(get(Type_Proxy["Proxy"].value)(f))();
                                        return addContextRecord1(Type_Proxy["Proxy"].value)(ctx)(f)();
                                    };
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var makeWithContextInitializer = function (dictInitialize) {
    var makeImpl1 = makeImpl(dictInitialize);
    return function (dictAddContext) {
        var addContext1 = addContext(dictAddContext);
        return function (p) {
            return function (opts) {
                return function (meta) {
                    return function (iv) {
                        return function (v) {
                            return bind2(makeImpl1(p)(opts)(meta)(iv)(v.value1))(function (field) {
                                return discard2(liftEffect(addContext1(v.value0)(field)))(function () {
                                    return pure1(field);
                                });
                            });
                        };
                    };
                };
            };
        };
    };
};
var initializeContextInitiali = function (dictAddContext) {
    return function (dictInitialize) {
        return {
            makeImpl: makeWithContextInitializer(dictInitialize)(dictAddContext)
        };
    };
};
var addContextT2 = function (dictAddContext) {
    var addContext1 = addContext(dictAddContext);
    return function (dictAddContext1) {
        var addContext2 = addContext(dictAddContext1);
        return {
            addContext: function (ctx) {
                return function (v) {
                    return function __do() {
                        addContext1(ctx)(v.value0)();
                        return addContext2(ctx)(v.value1)();
                    };
                };
            }
        };
    };
};
export {
    ContextInitializer,
    EffectInitializer,
    InitialValueInitializer,
    MappedField,
    Metadata,
    MetadataInitializer,
    NestedMetadata,
    NoInitialValue,
    NoInitializer,
    NoMetadata,
    RefWithOptions,
    SomeInitialValue,
    SomeInitializer,
    SomeMetadata,
    Undefined,
    Invalid,
    Valid,
    WithId,
    WithOptions,
    addContext,
    addContextRecord,
    addErrors,
    addErrorsPrefix,
    addErrorsRecord,
    annotateFinal,
    annotatedFinal,
    copyState,
    displayLocale,
    displayLocaleKey,
    displayedErrors,
    dumpState,
    dumpStateRecord,
    dynamicFromContext,
    dynamicFromContextDef,
    failFirst,
    fieldPathToString,
    forceDisplayErrors,
    forceDisplayErrorsKey,
    fromArray,
    fromChoices,
    fromRecord,
    getContext,
    getFieldId,
    getLabel,
    greaterThan,
    greaterThanOrEqual,
    greaterThanOrEqualFmt,
    hasDisplayedErrors,
    initializerFor,
    lessThan,
    lessThanOrEqual,
    liftMaybe,
    mSelectGetOptions,
    mSelectReadValue,
    mSelectTouch,
    mSelectWriteValue,
    make,
    makeImpl,
    makeRecordImpl,
    makeWithContextInitializer,
    makeWithDefaultInitializer,
    makeWithEffectInitializer,
    makeWithInitialValueInitializer,
    makeWithMetadataInitializer,
    makeWithSomeInitializer,
    mapDynamicFinal,
    mapMaybeFinal,
    mapMaybeFinalInternal,
    mapMaybeFinalUserVisible,
    mapVFinal,
    maybeContainerToArray,
    maybeGetInitialValue,
    maybeGetInitialValue$prime,
    maybeGetInitializer,
    maybeGetInitializer$prime,
    maybeGetMetadata,
    maybeGetMetadata$prime,
    merge,
    mergeInputRequired,
    mergeRecord,
    metaLabel,
    modifyRefLike,
    nonEmpty,
    optionForEq,
    readRefLike,
    requiredError,
    selectGetOptions,
    selectInput,
    selectReadValue,
    selectTouch,
    selectWriteValue,
    shorterThan,
    singleOption,
    someInitializer,
    tagErrors,
    textInput,
    toArray,
    toRecord,
    touchRefLike,
    unFinalFromContext,
    unFinalFromContextDef,
    unFinalWithDefault,
    validateJust,
    validateJustIf,
    validateTrue,
    validateWhenJust,
    withContext,
    withEffect,
    withFinal_,
    withId,
    withInitialValue,
    withMetadata,
    withNothing,
    withOptions,
    write,
    writeRef,
    writeRefLike,
    genericTypedValue,
    showTypedValue,
    encodeTypedValue,
    hasErrorsOldFormField,
    hasErrorsErrorArray,
    hasErrorsMappedField,
    hasErrorsWithId,
    hasErrorsWithOptions,
    hasErrorsRef,
    hasErrorsChoiceRef,
    hasErrorsDelayed,
    addErrorsRecord1,
    addErrorsRecordNil,
    addErrorsRecordCons,
    dumpState_Record,
    dumpStateRecordNil,
    dumpStateRecordCons,
    initializeNoInitialValueT,
    initializeSomeInitialValu1,
    initializeNoInitialValueT1,
    initializeNoInitialValueR,
    initializeSomeInitialValu,
    initializeRecordNil,
    maybeGetInitialValue1,
    maybeGetInitialValue$primeTrue,
    maybeGetInitialValue$primeFals,
    maybeGetInitializer1,
    maybeGetInitializer$primeTrue,
    maybeGetInitializer$primeFalse,
    maybeGetMetadataNoMetadat,
    maybeGetMetadataSomeMetad1,
    maybeGetMetadataSomeMetad2,
    maybeGetMetadataSomeMetad,
    maybeGetMetadata$primeTrueSome,
    maybeGetMetadata$primeFalseNoM,
    initializeRecordCons,
    makeWithInitialValueIniti,
    makeWithInitialValueIniti1,
    initializeInitialValueIni,
    initializeContextInitiali,
    initializeEffectInitializ,
    initializeNoInitializerRe,
    makeWithMetadataInitializ,
    initializeMetadataInitial,
    initializeSomeInitializer,
    asRecordRecord,
    asRecordNewtype,
    mergeRef,
    mergeChoiceRef,
    mergeDelayed,
    mergeT2T2,
    mergeUnit,
    merge_Record,
    mergeRecordNil,
    mergeRecordCons,
    addContextFormField,
    addContextRef,
    addContextEffect,
    addContextDynamic,
    addContextT2,
    addContextMaybe,
    addContext_Record,
    addContextRecordNil,
    addContextRecordCons,
    hasContextContext,
    hasContextRefContext,
    hasContextWithId,
    hasContextDelayed,
    hasLabelMappedField,
    isTextFieldRefString,
    isTextFieldFormFieldStrin,
    isTextFieldWithId,
    hasLabelWithId,
    hasOptionsArray,
    hasOptionsMaybeArray,
    hasOptionsSet,
    hasOptionsMaybeSet,
    hasOptionsMultiSet,
    hasOptionsMaybeMultiSet,
    hasOptions,
    isSelectFieldWithId,
    isRefLikeRef,
    isRefLikeFormField,
    hasLabelRef,
    hasLabelFormField,
    hasLabelRefWithOptions,
    hasErrorsRefWithOptions,
    isRefLikeWithId,
    hasFieldIdRefWithOptions,
    hasFieldIdWithOptions,
    isSelectFieldRefWithOptions,
    isSelectFieldChoiceRef,
    containerArray,
    containerSet,
    containerMaybe,
    isMultiSelectFieldMultiChoiceRef,
    isMultiSelectFieldRefWith,
    isMultiSelectFieldWithId,
    hasFieldIdString,
    hasFieldIdFormField,
    hasFieldIdChoiceRef,
    hasFieldIdRef,
    hasFieldIdFunctionEffect,
    hasFieldIdEffect,
    hasFieldIdWithId
};
export {
    afterInitialized
} from "../Restaumatic.Form.Delayed/index.js";
